// import { getCardsFromStr, getAllCards } from '@/helpers/cards'
// import { rangeTableGroups } from '@/helpers/solution'
// import { isValid as isValidDate } from 'date-fns'
// import { sanitizeBoard } from '@/store/router/router'
// import {
//   sitesOptions,
//   getGmfFormats,
//   getPracticeFilterGameformats,
//   getCardsValues,
// } from '@/helpers/constants'

function getTagFilteredTableData({ items, allTags, tagIds, anyall }) {
  const l_tagIds = tagIds.filter(id => allTags.some(i => i.id === id))
  if (!l_tagIds.length) {
    return items
  }
  const res = items.filter(d => {
    const tags = d.tags.map(i => i.id)
    if (!tags.length) {
      return false
    }
    if (anyall === 'all') {
      const rr = l_tagIds.every(id => tags.includes(id))
      return rr
    }
    const rr = l_tagIds.some(id => tags.includes(id))
    return rr
  })
  return res
}
/*
// import DOMPurify from 'dompurify';
 <img onload='javascript:alert(1)'>
 <script>alert(1)</script>
 alert(1)
 https://medium.com/@bsalwiczek/danger-of-using-v-html-in-vue-applications-see-better-approach-3def415ba32b
*/
/*

function getFilterDateKeypairs() {
  return [
    // date_from date_to
    ['date_played_after', 'date_played_before'],
    ['created_at_after', 'created_at_before'],
  ]
}

function getAnalyzeHandsFilterOptions() {
  const site = sitesOptions().map(i => i.id)
  return {
    file: '',
    filename: '',
    marked: ['true'],
    date_played_after: '',
    date_played_before: '',
    site,
    ev_mistake: ['0', '-0.5', '-1', '-2', '-3', '-4', '-5'],
    amount_won: ['10', '20', '50'],
    total_pot: ['10', '20', '50'],
    position: ['UTG', 'UTG+1', 'UTG+2', 'LJ', 'HJ', 'CO', 'BTN', 'SB', 'BB', 'STR'],
    street: ['preflop', 'postflop'],
    hand: rangeTableGroups(),
    board: getAllCards(),
  }
}

// function getAnalyzeHandsFilterOptionsV2({ getters }) {
function getAnalyzeHandsFilterOptionsV2() {
  const site = sitesOptions().map(i => i.id)
  // let apiBlinds = getters ? getters.api_get_data('api_v2_hh_blinds') || [] : []
  return {
    file: '',
    filename: '',
    marked: ['true'],
    date_played_after: '',
    date_played_before: '',
    site,
    ev_mistake: ['0', '-0.5', '-1', '-2', '-3', '-4', '-5'],
    amount_won: ['10', '20', '50'],
    total_pot: ['10', '20', '50'],
    position: ['UTG', 'UTG+1', 'UTG+2', 'LJ', 'HJ', 'CO', 'BTN', 'SB', 'BB', 'STR'],
    street: ['preflop', 'postflop'],
    hand: rangeTableGroups(),
    board: getAllCards(),

    status: ['some-status'],
    gto_score: ['777', '999'],

    // small_blind: apiBlinds.map(i => i.small_blind),
    // big_blind: apiBlinds.map(i => i.big_blind),

    small_blind: [], // any
    big_blind: [], // any

    // gameformat: getPracticeFilterGameformats(),
    // total_ev_loss: ['0', '0.25', '0.5', '1', '2', '5'],
    // total_ev_loss_as_pot: ['0', '0.005', '0.01', '0.02', '0.05'],
    // total_frequency_difference: ['0', '0.25', '0.5', '0.75', '1'],

    // tag_ids: '',
    // tag_anyall: ['all'],
  }
}

function getPracticeSessionsFilterOptions() {
  return {
    marked: ['true'],
    created_at_after: '',
    created_at_before: '',
    gameformat: getPracticeFilterGameformats(),
  }
}

function getDrillsFilterOptions() {
  return {
    favorite: ['true'],
    drill_type: ['public_drills'],
    // drill_type: ['my_drills', 'public_drills'],
    l_gmf_format: getGmfFormats(),
    tag_ids: '',
    tag_anyall: ['all'],
    // tag_anyall: ['any', 'all'],
  }
}

function getSavedTreesFilterOptions() {
  return {
    tag_ids: '',
    tag_anyall: ['all'],
  }
}
function getCustomSolutionsFilterOptions() {
  return {
    tag_ids: '',
    tag_anyall: ['all'],
    board: getAllCards(),
    // custom_solution__similar
    is_favorite: ['true'],
    positions: [
      'UTG',
      'UTG1',
      'UTG2',
      'LJ',
      'HJ',
      'CO',
      'BTN',
      'SB',
      'BB',
      // 'MP',
      'STR',
      'OOP',
      'IP',
    ],
    positions_anyall: ['all'],
    // positions_all:['BB', 'BTN', 'CO', 'HJ', 'IP', 'LJ', 'MP', 'OOP', 'SB', 'STR', 'UTG', 'UTG1', 'UTG2'],
    // positions_any:['BB', 'BTN', 'CO', 'HJ', 'IP', 'LJ', 'MP', 'OOP', 'SB', 'STR', 'UTG', 'UTG1', 'UTG2'],
    starting_street: ['preflop', 'flop'],
  }
}
function getSavedRangesFilterOptions() {
  return {
    tag_ids: '',
    tag_anyall: ['all'],
  }
}
function getSavedFiltersFilterOptions() {
  return {
    tag_ids: '',
    tag_anyall: ['all'],
  }
}
function getSavedSpotsFilterOptions() {
  return {
    tag_ids: '',
    tag_anyall: ['all'],
  }
}
// function getCustomSolutionsFilterOptions() {
//     return {
//         // tag_ids: '',
//         // tag_anyall: ['all'],
//         created_at_after: '',
//         created_at_before: '',
//     }
// }

function getPracticeHandsFilterOptions() {
  return {
    session: '',
    session_name: '',
    drill: '',
    drill_name: '',
    marked: ['true'],
    created_at_after: '',
    created_at_before: '',
    hand: rangeTableGroups(),
    hero: ['UTG', 'UTG+1', 'UTG+2', 'LJ', 'HJ', 'CO', 'BTN', 'SB', 'BB', 'STR', 'OOP', 'IP'],
    total_ev_loss: ['0', '0.25', '0.5', '1', '2', '5'],
    total_ev_loss_as_pot: ['0', '0.005', '0.01', '0.02', '0.05'],
    total_frequency_difference: ['0', '0.25', '0.5', '0.75', '1'],
    spot_type: ['PREFLOP', 'SRP', '3bet', '4bet', '5bet', 'Squeeze', 'limp', 'iso'],
    gameformat: getPracticeFilterGameformats(),
  }
}
function getReportsFlopFilterOptions() {
  return {
    flop_suits: ['rainbow', 'flush_draw', 'monotone'],
    flop_paired: ['not_paired', 'paired', 'tripled'],
    flop_connectedness: ['disconnected', 'oesd_possible', 'connected'],
    flop_subset: ['25', '49', '85', '184'],
    flop_high_card: getCardsValues(),
    flop_mid_card: getCardsValues(),
    flop_low_card: getCardsValues(),
  }
}

function getUrlVals({ params, key, id }) {
  const urlKey = `${id}_${key}`
  let res = params.get(urlKey) || ''
  return res
}

function checkCommon({ key, vals, res, singles, options }) {
  const dateKeypairs = getFilterDateKeypairs()
  const dateKeyPair = dateKeypairs.find(pp => pp[0] in options) || []
  // debugger
  // if (key.includes('drill_type')) {
  // vals = [...new Set(vals.split(',').filter(i => i))]
  // res[key] = vals.length ? vals : ['my_drills']
  // } else
  if (key.includes('tag_ids')) {
    vals = [...new Set(vals.split(',').filter(i => i))]
    res[key] = vals
  } else if (key.includes('favorite')) {
    res[key] = vals === 'true'
  } else if (key.includes('marked')) {
    res[key] = vals === 'true'
  } else if (dateKeyPair.some(kk => key === kk)) {
    const date = new Date(vals)
    res[key] = isValidDate(date) ? vals : ''
    if (key.includes('_before')) {
      if (!res[dateKeyPair[0]] || !res[dateKeyPair[1]]) {
        res[dateKeyPair[0]] = ''
        res[dateKeyPair[1]] = ''
      }
    }
  } else if (key === 'board') {
    let cards = getCardsFromStr(vals)
    cards = sanitizeBoard(cards)
    vals = cards.join('')
    res[key] = vals
  } else {
    vals = [...new Set(vals.split(',').filter(i => i))]
    vals = vals.filter(val => (options[key] || []).some(v => v === val))
    res[key] = singles[key] ? [vals[0]] : vals
  }
  // console.log(res)
  return res
}

function checkAnalyzeHandsFilterQuery({ options, id, singles = {} }) {
  let res = {}
  let params = new URL(document.location).searchParams
  Object.keys(options).forEach(key => {
    const vals = getUrlVals({ params, key, id })
    if (key.includes('file')) {
      res[key] = vals || ''
      if (key === 'filename') {
        if (!res.file || !res.filename) {
          res.file = ''
          res.filename = ''
        }
      }
    } else {
      res = checkCommon({ key, vals, res, singles, options })
    }
  })
  // console.log(res)
  return res
}
function checkAnalyzeHandsFilterQueryV2({ options, id, singles = {} }) {
  let res = {}
  let params = new URL(document.location).searchParams
  Object.keys(options).forEach(key => {
    let vals = getUrlVals({ params, key, id })
    if (key.includes('file')) {
      res[key] = vals || ''
      if (key === 'filename') {
        if (!res.file || !res.filename) {
          res.file = ''
          res.filename = ''
        }
      }
    } else if (['big_blind', 'small_blind'].some(kk => key.includes(kk))) {
      vals = [
        ...new Set(
          vals.split(',').filter(
            i =>
              i &&
              i !== '1e10000' && // infinity - in case someone enters it manually
              !isNaN(i),
          ),
        ),
      ]
      vals = vals.map(v => Number(v))
      res[key] = vals || ''
    } else {
      res = checkCommon({ key, vals, res, singles, options })
    }
  })
  // console.log(res)
  return res
}
function checkPracticeHandsFilterQuery({ options, id, singles = {} }) {
  let res = {}
  let params = new URL(document.location).searchParams
  Object.keys(options).forEach(key => {
    const vals = getUrlVals({ params, key, id })
    if (key.includes('session')) {
      res[key] = vals || ''
      if (key === 'session_name') {
        if (!res.session || !res.session_name) {
          res.session = ''
          res.session_name = ''
        }
      }
    } else if (key.includes('drill')) {
      res[key] = vals || ''
      if (key === 'drill_name') {
        if (!res.drill || !res.drill_name) {
          res.drill = ''
          res.drill_name = ''
        }
      }
    } else {
      res = checkCommon({ key, vals, res, singles, options })
    }
  })
  // console.log(res)
  return res
}
function checkCommonFilterQuery({ options, id, singles = {} }) {
  let res = {}
  let params = new URL(document.location).searchParams
  Object.keys(options).forEach(key => {
    const vals = getUrlVals({ params, key, id })
    res = checkCommon({ key, vals, res, singles, options })
  })
  // console.log(res)
  return res
}


function getAnalyzeHandsFilter() {
  const id = 'ffah'
  const options = getAnalyzeHandsFilterOptions()
  let query = checkAnalyzeHandsFilterQuery({ options, id })
  const res = {
    id,
    key: 'filters_analyze_hands',
    // tableId: 'hhhandsv1', for favoriting the filters (not implemented yet)
    query,
    options,
  }
  // console.log(res)
  return res
}

function getAnalyzeHandsFilterV2() {
  const id = 'ffahv2'
  // const options = getAnalyzeHandsFilterOptionsV2({ getters })
  const options = getAnalyzeHandsFilterOptionsV2()
  let query = checkAnalyzeHandsFilterQueryV2({ options, id })
  const res = {
    id,
    key: 'filters_analyze_hands_v2',
    // tableId: 'hhhandsv2', for favoriting the filters (not implemented yet)
    query,
    options,
    getApiTransform: ffprms => {
      if (ffprms.tag_ids) {
        if (ffprms.tag_anyall?.[0] === 'all') {
          ffprms.tag_ids_all = ffprms.tag_ids
        } else {
          ffprms.tag_ids_any = ffprms.tag_ids
        }
      }
      delete ffprms.tag_anyall
      delete ffprms.tag_ids
      return ffprms
    },
  }
  // console.log(res)
  return res
}
function getPracticeHandsFilter() {
  const id = 'ffph'
  const options = getPracticeHandsFilterOptions()
  let query = checkPracticeHandsFilterQuery({ options, id })
  const res = {
    id,
    key: 'filters_practice_hands',
    // tableId: 'practicehands', for favoriting the filters (not implemented yet)
    query,
    options,
  }
  return res
}
function getPracticeSessionsFilter() {
  const id = 'ffps'
  const options = getPracticeSessionsFilterOptions()
  let query = checkCommonFilterQuery({ options, id })
  const res = {
    id,
    key: 'filters_practice_sessions',
    query,
    options,
  }
  return res
}

function getReportsFlopFilter() {
  const id = 'ffrf'
  const options = getReportsFlopFilterOptions()
  // let query = checkPracticeSessionsFilterQuery({ options, id })
  // has no url
  let query = {}
  const res = {
    id,
    key: 'filters_reports_flop',
    noUrlUpdate: true,
    query,
    options,
  }
  return res
}

function getDrillsFilter() {
  const id = 'ffdf'
  const options = getDrillsFilterOptions()
  let query = checkCommonFilterQuery({ options, id })
  const res = {
    id,
    key: 'filters_drills',
    tagType: 'drills',
    query,
    options,
  }
  return res
}

function getSavedFiltersFilter() {
  const id = 'ffsf'
  const options = getSavedFiltersFilterOptions()
  let query = checkCommonFilterQuery({ options, id })
  const res = {
    id,
    key: 'filters_saved_filters',
    tagType: 'saved_filters',
    tagHasEdit: true,
    query,
    options,
  }
  return res
}

function getSavedSpotsFilter() {
  const id = 'ffss'
  const options = getSavedSpotsFilterOptions()
  let query = checkCommonFilterQuery({ options, id })
  const res = {
    id,
    key: 'filters_saved_spots',
    tagType: 'saved_spots',
    tagHasEdit: true,
    query,
    options,
  }
  return res
}

function getCustomSolutionsFilter() {
  const id = 'ffcs'
  const options = getCustomSolutionsFilterOptions()
  let query = checkCommonFilterQuery({ options, id })
  const res = {
    id,
    key: 'filters_custom_solutions',
    // tagType: 'saved_solutions',
    tagType: 'custom_solutions',
    tagHasEdit: true,
    query,
    options,
    getApiTransform: ffprms => {
      if (ffprms.positions) {
        if (ffprms.positions_anyall?.[0] === 'all') {
          ffprms.positions_all = ffprms.positions
        } else {
          ffprms.positions_any = ffprms.positions
        }
      }

      if (ffprms.tag_ids) {
        if (ffprms.tag_anyall?.[0] === 'all') {
          ffprms.tag_ids_all = ffprms.tag_ids
        } else {
          ffprms.tag_ids_any = ffprms.tag_ids
        }
      }

      if (ffprms.starting_street) {
        ffprms.starting_street = ffprms.starting_street.map(i => i.toUpperCase())
      }

      delete ffprms.positions
      delete ffprms.positions_anyall
      delete ffprms.tag_anyall
      delete ffprms.tag_ids
      return ffprms
    },
  }
  return res
}

function getSavedTreesFilter() {
  const id = 'ffts'
  const options = getSavedTreesFilterOptions()
  let query = checkCommonFilterQuery({ options, id })
  const res = {
    id,
    key: 'filters_saved_trees',
    tagType: 'saved_trees',
    tagHasEdit: true,
    query,
    options,
  }
  return res
}

function getSavedRangesFilter() {
  const id = 'ffsr'
  const options = getSavedRangesFilterOptions()
  let query = checkCommonFilterQuery({ options, id })
  const res = {
    id,
    key: 'filters_saved_ranges',
    tagType: 'saved_ranges',
    tagHasEdit: true,
    query,
    options,
  }
  return res
}
*/

// function getCustomSolutionsFilter() {
//     const id = 'ffcl'
//     const options = getCustomSolutionsFilterOptions()
//     let query = checkCommonFilterQuery({ options, id })
//     const res = {
//         id,
//         key: 'filters_custom_solutions',
//         // tagType: 'custom_solutions',
//         tagHasEdit: true,
//         query,
//         options,
//     }
//     return res
// }

const getFilterBase = () => ({
  loaded: false,
  data: null,
  params: null,
  filter: null,
  active: false,
})

// Well cleanup this after we have all the filters checked
export {
  getFilterBase,
  // getAnalyzeHandsFilter,
  // getAnalyzeHandsFilterV2,
  // getAnalyzeHandsFilterOptions,
  // getAnalyzeHandsFilterOptionsV2,
  // getPracticeHandsFilter,
  // getPracticeHandsFilterOptions,
  // getPracticeSessionsFilter,
  // getPracticeSessionsFilterOptions,
  // getFilterDateKeypairs,
  // getReportsFlopFilter,
  // getDrillsFilter,
  // getSavedFiltersFilter,
  // getSavedSpotsFilter,
  // getPracticeHandsFilter,
  getTagFilteredTableData,
  // getCustomSolutionsFilter,
  // getSavedTreesFilter,
  // getCustomSolutionsFilter,
  // getSavedRangesFilter,
}
